import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { FontFamily } from "../../theme/typography";
import { useTheme } from "../../context/themeContext";

interface ModalHeaderProps {
  readonly placeholder: string;
  readonly count: number;
  readonly isDark: boolean;
  readonly accentColor: string;
  readonly onClose: () => void;
}

export const ModalHeader: React.FC<ModalHeaderProps> = ({ placeholder, count, isDark, accentColor, onClose }) => {
  const { theme } = useTheme();
  const { colors } = theme;
  return (
    <View style={[s.modalHeader, { borderColor: colors.line }]}>
      <View style={[s.accentBar, { backgroundColor: accentColor }]} />
      <Text style={[s.modalTitle, { color: isDark ? colors.ink3 : colors.ink }]}>{placeholder}</Text>
      <View style={[s.countBadge, { backgroundColor: colors.accentSoft }]}>
        <Text style={[s.countText, { color: accentColor }]}>{count}</Text>
      </View>
      <TouchableOpacity onPress={onClose} activeOpacity={0.7} style={[s.closeBtn, { backgroundColor: colors.paper2 }]}>
        <View style={[s.closeLine1, { backgroundColor: colors.ink3 }]} />
        <View style={[s.closeLine2, { backgroundColor: colors.ink3 }]} />
      </TouchableOpacity>
    </View>
  );
};

const s = StyleSheet.create({
  modalHeader: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 20,
    paddingTop: 14,
    paddingBottom: 14,
    borderBottomWidth: 1,
    gap: 10,
  },
  accentBar: { width: 3, height: 16, borderRadius: 2 },
  modalTitle: { flex: 1, fontSize: 12, fontWeight: "800", letterSpacing: 1.4, textTransform: "uppercase", fontFamily: FontFamily.sans },
  countBadge: { paddingHorizontal: 8, paddingVertical: 3, borderRadius: 10 },
  countText: { fontSize: 11, fontWeight: "700", fontFamily: FontFamily.sans },
  closeBtn: { width: 28, height: 28, borderRadius: 8, justifyContent: "center", alignItems: "center", marginLeft: 4 },
  closeLine1: { position: "absolute", width: 12, height: 1.5, borderRadius: 1, transform: [{ rotate: "45deg" }] },
  closeLine2: { position: "absolute", width: 12, height: 1.5, borderRadius: 1, transform: [{ rotate: "-45deg" }] },
});
